// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__RbLvd","approved":"Status_approved__O0gtU","rejected":"Status_rejected__btD5V","expired":"Status_expired__g53jm","label":"Status_label__eYkly"};